import { defineMessages } from "react-intl";

const messages = defineMessages({
  noTeam: {
    id: "settings.manageFields.editPane.fieldAccess.teams.noTeam",
    defaultMessage: "Users without a team",
    description: "No Team item title on Manage fields panel",
  },
  searchPlaceholder: {
    id: "settings.manageFields.editPane.fieldAccess.teams.search.placeholder",
    defaultMessage: "Search teams",
    description: "Search Teams placeholder",
  },
});

export default messages;
